import React from 'react';
import { FaBuilding, FaHandsHelping, FaRegHeart, FaGlobeAmericas, FaCertificate } from 'react-icons/fa';

// Componente para a Missão/Visão/Valores
const MvvItem = ({ icon: Icon, title, description }) => (
  <div className="flex flex-col items-center text-center p-6 bg-white rounded-xl shadow-lg h-full">
    <Icon className="w-10 h-10 mb-4 text-[#4DA391]" />
    <h3 className="text-xl font-bold text-[#3A4785] mb-2">{title}</h3>
    <p className="text-gray-700 text-sm">{description}</p>
  </div>
);

// Componente Principal
function SobreNosKeralty() {

  return (
    <div className="min-h-screen lg:pt-20 bg-gray-50">

      {/* Seção 1: Cabeçalho (Azul Escuro) */}
      <header className={`bg-primary pt-10 pb-20 px-4 md:px-8 text-white text-center`}>
        <div className="max-w-4xl mx-auto">
          
          {/* Ícone Institucional (Mantenho o estilo do coração ou da Keralty) */}
          <div className="mb-6">
            <FaBuilding className={`w-16 h-16 mx-auto text-third`} />
          </div>

          <h1 className="text-4xl md:text-5xl font-extrabold mb-2">
            Sobre Nós
          </h1>
          <p className="text-lg md:text-xl px-4">
            Associação Keralty Brasil: Cuidado, Apoio e Transformação Social.
          </p>
        </div>
      </header>

      {/* Seção Principal de Conteúdo */}
      <main className="max-w-6xl mx-auto -mt-12 px-4 md:px-8">
        
        {/* Bloco 2: História e Contexto */}
        <section className={`bg-white p-10 rounded-xl shadow-2xl mb-12 border-t-8 border-third`}>
          <h2 className={`text-3xl font-bold text-primary mb-6 text-center`}>
            Nossa História e Compromisso
          </h2>
          <div className="text-gray-700 leading-relaxed text-lg space-y-4">
            <p>
              A Associação Keralty Brasil é o braço social do Grupo Keralty no país, dedicada a promover o bem-estar e a qualidade de vida de comunidades vulneráveis. Desde a nossa fundação, atuamos com a convicção de que o cuidado transcende o ambiente clínico, abraçando o apoio emocional, social e recreativo.
            </p>
            <p>
              Nossa atuação foca em três pilares principais: Apoio a Crianças Atípicas, Cuidados Paliativos e Companhia a Idosos em Casas de Repouso. Trabalhamos em parceria com uma rede de voluntários apaixonados e profissionais da saúde para garantir que cada vida tocada receba dignidade, carinho e o suporte necessário para enfrentar seus desafios.
            </p>
            <p className="border-l-4 border-l-[#3A4785] pl-4 py-2 italic text-gray-600">
              "Acreditamos no poder da solidariedade e no impacto transformador de um gesto de cuidado."
            </p>
          </div>
        </section>

        {/* Bloco 3: Missão, Visão e Valores (MVV) */}
        <section className="py-8 mb-12">
          <h2 className={`text-3xl font-bold text-primary mb-8 text-center`}>
            Nossa Missão, Visão e Valores
          </h2>
          <div className="grid md:grid-cols-3 gap-8">
            
            <MvvItem
              icon={FaHandsHelping}
              title="Missão"
              description="Promover o desenvolvimento humano e a inclusão social, oferecendo suporte integral e dignidade a indivíduos com necessidades especiais e em situação de vulnerabilidade."
            />

            <MvvItem
              icon={FaGlobeAmericas}
              title="Visão"
              description="Ser referência nacional em voluntariado e apoio social na área da saúde, reconhecida pela excelência, transparência e impacto positivo nas comunidades atendidas."
            />

            <MvvItem
              icon={FaRegHeart}
              title="Valores"
              description="Empatia, Humanização, Comprometimento, Ética e Inovação no Cuidado."
            />

          </div>
        </section>
        
        {/* Bloco 4: Chamada para Ação Global */}
        <div className={`bg-primary p-8 rounded-xl shadow-lg text-white text-center mb-12`}>
            <FaCertificate className="w-12 h-12 mx-auto text-[#9BC53D] mb-4" />
            <p className="text-xl font-semibold mb-4">
                Parte de um Grupo Global de Saúde
            </p>
            <p className="text-sm">
                A Associação Keralty Brasil se beneficia da experiência e do padrão de qualidade internacional do Grupo Keralty, reforçando nosso compromisso com a excelência no cuidado e na responsabilidade social.
            </p>
        </div>

      </main>
      
      {/* Seção 5: CTA Simples no final */}
      <div className="text-center py-10 bg-gray-50">
        <p className={`text-2xl font-semibold text-primary mb-6`}>
          Junte-se a nós nesta missão!
        </p>
        <button
          className={`bg-fourth hover:bg-opacity-80 text-white font-bold py-3 px-8 rounded-full text-lg shadow-xl transition duration-300 ease-in-out transform hover:scale-105`}
          onClick={() => alert('Direcionando para a página de voluntariado...')}
        >
          Seja um Voluntário
        </button>
      </div>

    </div>
  );
};

export default SobreNosKeralty;